// MonitoramentoDemo.jsx
import React, { useState, useEffect } from 'react';
import '../../styles/desktop/water-tank.css';
import "../../styles/desktop/AlarmeModal.css";
import './AlarmeObjeto/Alarmes'
import Alarmes from './AlarmeObjeto/Alarmes';
import { getCaixaDAgua } from '../../API/basic/getCaixaDAgua';

// Componente individual para cada caixa d'água
const WaterTank = ({ tankData }) => {
  // Definição dos níveis de água
  const LEVELS = {
    OVERFLOW: 80, // Nível de extravasão (80%)
    LOW: 20,      // Nível baixíssimo (20%)
  };

  // Determina a classe CSS para o nível da água
  const getWaterLevelClass = () => {
    if (tankData.nivel >= LEVELS.OVERFLOW) return "water-level-overflow"  ;
    if (tankData.nivel <= LEVELS.LOW) return "water-level-low";
    return "water-level-normal";
  };

  // Determina o status do nível da água para exibição
  const getWaterStatusDisplay = () => {
    if (tankData.nivel >= LEVELS.OVERFLOW) return "Extravasão";
    if (tankData.nivel <= LEVELS.LOW) return "Baixíssimo";
    return "Normal";
  };

  // Determina a classe CSS para o texto de status
  const getStatusClass = () => {
    if (tankData.nivel >= LEVELS.OVERFLOW) return "status-overflow";
    if (tankData.nivel <= LEVELS.LOW) return "status-low";
    return "status-normal";
  };

  return (
    <div className="water-tank-card">
      <h3 className="water-tank-title">{tankData.nome}</h3>
      
      <div className="tank-container">
        {/* Imagem de fundo da caixa d'água */}
        <div className="tank-background-image"></div>
        
        {/* Nível da água */}
        <div 
          className={`water-level ${getWaterLevelClass()}`} 
          style={{ height: `${tankData.nivel}%` }}
        ></div>
        
        {/* Linhas de marcação */}
        <div>
          {/* Linha de extravasão */}
          <div 
            className="tank-marker marker-overflow" 
            style={{ top: `${100 - LEVELS.OVERFLOW}%` }}
          >
            <span className="marker-label label-overflow">
              Extravasão
            </span>
          </div>
          
          {/* Linha de baixíssimo */}
          <div 
            className="tank-marker marker-low" 
            style={{ bottom: `${LEVELS.LOW}%` }}
          >
            <span className="marker-label label-low">
              Baixíssimo
            </span>
          </div>
        </div>
        
        {/* Indicador de porcentagem centralizado */}
        <div className="tank-center-indicator">
          <div className="tank-percentage-box">
            <span className="tank-percentage-text">{tankData.nivel}%</span>
          </div>
        </div>
      </div>
      
      {/* Informações da caixa */}
      <div className="info-grid">
        <div className="info-card">
          <div className="info-label">Volume Atual</div>
          <div className="info-value">{tankData.volume} L</div>
        </div>
        
        <div className="info-card">
          <div className="info-label">Capacidade</div>
          <div className="info-value">{tankData.capacidadeTotal} L</div>
        </div>
        
        <div className="info-card">
          <div className="info-label">Status</div>
          <div className={`info-value ${getStatusClass()}`}>
            {getWaterStatusDisplay()}
          </div>
        </div>
      </div>
      
      <div className="tank-timestamp">
        Última atualização: {new Date(tankData.timestamp).toLocaleString()}
      </div>
    </div>
  );
};

// Componente principal que gerencia múltiplas caixas d'água
const WaterTankDashboard = ({ tanksData }) => {
  // Calcula o estilo do grid com base no número de caixas
  const gridStyle = {
    gridTemplateColumns: `repeat(${tanksData.length}, minmax(300px, 1fr))`,
    width: tanksData.length > 3 ? 'max-content' : '100%', // Largura fixa para menos de 3, senão ajusta ao conteúdo
    justifyContent: tanksData.length < 3 ? 'center' : 'flex-start' // Centraliza quando há poucas caixas
  };

  return (
    <div className="water-tank-dashboard">
      <h1 className="water-tank-header">Monitoramento de Caixas D'água</h1>
      
      <div className="water-tank-scroll-container">
        {tanksData.length === 0 ? (
          <div className="empty-message">
            Nenhuma caixa d'água cadastrada para monitoramento.
          </div>
        ) : (
          <div className="water-tank-grid" style={gridStyle}>
            {tanksData.map((tank, index) => (
              <WaterTank key={index} tankData={tank} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// Aplicação de demonstração
const WaterTankMonitoringDemo = () => {
  const [tanksData, setTanksData] = useState([]);
  const [tankCount, setTankCount] = useState(1); // Começa com 1 caixa por padrão para centralizar
  
  // Gera dados iniciais e configura atualização periódica
  useEffect(() => {
    const fetchTanksData = async () => {
      const dadosAPI = await getCaixaDAgua();
  
      const dadosConvertidos = dadosAPI.map((item) => ({
        nome: item.nome,
        nivel: item.percentual, // <-- renomeando "percentual" para "nivel"
        volume: item.litrosAtuais, // <-- renomeando "litrosAtuais" para "volume"
        capacidadeTotal: item.capacidadeTotal,
        status: item.status, 
        timestamp: new Date().toISOString(), // Apenas para exibição
      }));
  
      setTanksData(dadosConvertidos);
      setTankCount(dadosConvertidos.length);
      
    };
  
    fetchTanksData();
    const intervalId = setInterval(fetchTanksData, 5000);
    return () => clearInterval(intervalId);
  }, []);
  

  return (
    <div className="app-container">
      <div className="water-tank-container">
    
        {/* Exibe o dashboard com os dados simulados */}
        <WaterTankDashboard tanksData={tanksData} />
        
      </div>

      <div className='campoAlarmes'>
          <Alarmes/>
      </div>
    
    </div>
  );
};

export default WaterTankMonitoringDemo;